import { CardItem, ComponentAlignment, MaterialIcon } from '@makyoapp/makyo-tw-ui'

import { LayoutDemo } from './LayoutDemo'

const mockCard = [
  {
    title: 'Design System Meeting',
    description: 'Line 2 content',
    contentTitle:
      'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore.',
    contentSubtitle: '',
    contentSupportingText: '',
    metadata: '',
    image: (
      <img
        src='https://a3q5.c18.e2-3.dev/makyo-dev/assets/images/landscapes/land3.jpg'
        className='w-full h-full object-cover shrink-0'
        style={{ clipPath: 'inset(0px)', aspectRatio: '4 / 3' }}
      />
    ),
    mediaType: 'image',
    avatar: 'https://i.pravatar.cc/150?img=32',
    avatarType: 'image' as const,
    avatarVariant: 'filled' as const,
    authorName: 'John Doe',
    date: 'March 15, 2024',
    readTime: '5 min read',
    views: '1.2k views',
    comments: '8 comments',
    tags: ['Design', 'UI/UX', 'Development'],
  },
]

export const CardItemsDemo = () => {
  return (
    <LayoutDemo title='Card' bgColor='var(--color-primary-90)'>
      {mockCard.map((card) => {
        const args = {
          orientation: 'vertical' as const,
          outlined: false,
          elevated: false,
          cornerRadius: 'medium' as const,
          backgroundColor: 'primary-95' as const,
          showAvatar: true,
          card: card,
          showImage: true,
          textLine1Typography: 'title-small' as any,
          textLine1Alignment: 'start' as ComponentAlignment,
          textLine2Typography: 'body-medium' as any,
          textLine2Alignment: 'start' as ComponentAlignment,
          textLine3Typography: 'body-medium' as any,
          textLine3Alignment: 'start' as ComponentAlignment,
          textLine3Limit: 2,
          textLine4Typography: 'body-small' as any,
          textLine4Alignment: 'start' as ComponentAlignment,
          textLine5Typography: 'body-small' as any,
          textLine5Alignment: 'start' as ComponentAlignment,
          metadataTypography: 'body-small' as any,
          metadataAlignment: 'start' as ComponentAlignment,
          metadataLimit: 1,
          footerAreaTypography: 'label-large' as any,
          footerAreaAlignment: 'start' as ComponentAlignment,
          footerAreaLimit: 1,
          aspectRatio: '16:9',
          footerTitle: '',
          footerTitleAlignment: 'start' as ComponentAlignment,
          leading: {
            enabled: true,
            text: 'Primary',
            typography: 'label-large' as any,
            colorVariant: 'primary-80' as const,
            shape: 'medium' as const,
            size: 'md' as const,
            disabled: false,
            elevation: true,
            border: false,
            iconPosition: 'leading' as const,
            icon: <MaterialIcon icon='thumb_up' />,
            onClick: () => console.log('Primary action clicked'),
          },
          trailing: {
            enabled: true,
            text: 'Secondary',
            typography: 'label-large' as any,
            colorVariant: 'secondary-80' as const,
            shape: 'medium' as const,
            size: 'md' as const,
            disabled: false,
            elevation: false,
            border: false,
            iconPosition: 'trailing' as const,
            icon: <MaterialIcon icon='share' />,
            onClick: () => console.log('Secondary action clicked'),
          },
          metadata: {
            showDate: true,
            showReadTime: true,
            showTags: true,
            showViews: true,
            showComments: true,
          },
          showDivider: true,
          cardVariant: 'Filled' as const,
          footerDropdownItems: [],
          headerDropdownItems: [],
        }

        // todo: there is an error padding on CardItem in not provided
        return (
          <CardItem
            key={card.title}
            {...args}
            padding={{ top: 20, right: 20, bottom: 20, left: 20 }}
            backgroundColorPage='primary-90'
          />
        )
      })}
    </LayoutDemo>
  )
}
